interface ICuratedDestination {
  id: string;
  name: string;
  lat: string;
  long: string;
}

// Keyed by lowercase, trimmed destination name -- independent of brand/locale.
// See products/eg-affiliate-products/docs/curated-destination-mapping.md for the
// mapping contract (V1: name-only prefill resolved server-side via this map).
const CURATED_DESTINATIONS: Record<string, ICuratedDestination> = {
  'mississippi gulf coast': {
    id: '6058666',
    name: 'Mississippi Gulf Coast',
    lat: '30.3',
    long: '-89.3',
  },
};

export { CURATED_DESTINATIONS, ICuratedDestination };
